import { useEffect } from "react";

const upsert = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export default function SeoHead({ title, description, path, jsonLd, image }) {
  useEffect(() => {
    document.title = title;
    upsert("name", "description", description);
    upsert("property", "og:title", title);
    upsert("property", "og:description", description);
    upsert("property", "og:url", window.location.origin + path);
    upsert("property", "og:type", "article");
    if (image) {
      const abs = window.location.origin + image;
      upsert("property", "og:image", abs);
      upsert("name", "twitter:card", "summary_large_image");
      upsert("name", "twitter:image", abs);
    }
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script) document.head.removeChild(script);
    };
  }, [title, description, path, jsonLd]);
  return null;
}
